import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PopoverContent, QueryBarItemSingle } from "@similarweb/ui-components";

import { SharedSearchInputStyles } from "app/pages/sales-intelligence/pages/company-analysis/styles";

export const StyledHeaderLink = styled.a`
    color: ${colorsPalettes.carbon[400]};
    text-decoration: none;

    &:hover {
        color: ${colorsPalettes.blue[400]};
    }
`;

export const StyledQueryBarItem = styled(QueryBarItemSingle)`
    min-width: 76px;
    max-width: 180px;
`;

export const StyledPopoverContent = styled(PopoverContent)`
    min-width: 493px;
    padding: 0;
`;

export const StyledScrollableContent = styled.div`
    max-height: 384px;
    overflow-y: auto;
`;

export const StyledSearchContainer = styled.div<{ isLoading?: boolean }>`
    border-bottom: ${({ isLoading = false }) => (isLoading ? "none" : `1px solid ${colorsPalettes.blue[400]}`)};

    .SearchInput-container {
        flex-grow: 1;
        margin: 0;

        .SearchInput {
            height: 40px;
            ${SharedSearchInputStyles}
        }
    }
`;
